import type { ApiSpMovingData, SpMoving, SpMovingCellGroup } from "./types";

/**
 * Суммирует количество по движениям размещения в местах хранения.
 * @param movements движения `spMoving`; при `undefined` возвращает `0`
 * @returns суммарное размещённое количество
 */
export function sumSpMovingQty(movements: ApiSpMovingData[] | undefined): number {
    return movements?.reduce((sum, movement) => sum + movement.Qty, 0) ?? 0;
}

/**
 * Группирует движения размещения по ячейке (`SpCode`) с суммой `Qty`. \
 * Используется для «Фактическое МХ» и списка отмены размещения вместо `loadRemaindersByFilter`.
 * @param movements движения строки состава; при `undefined`/пустом массиве возвращает `[]`
 */
export function groupSpMovingsByCell(movements: SpMoving[] | undefined): SpMovingCellGroup[] {
    if (movements == null || movements.length === 0) {
        return [];
    }

    const groups = new Map<number, SpMovingCellGroup>();

    movements.forEach((movement) => {
        if (movement.SpCode === 0) {
            return;
        }

        const existing = groups.get(movement.SpCode);
        if (existing != null) {
            existing.Qty += movement.Qty;
            if (existing.StorePlace == null && movement.StorePlace != null) {
                existing.StorePlace = movement.StorePlace;
            }
            return;
        }

        groups.set(movement.SpCode, {
            SpCode: movement.SpCode,
            Qty: movement.Qty,
            StorePlace: movement.StorePlace,
        });
    });

    return [...groups.values()];
}
